import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { LoginAfterCheckLogin,ChangeMobileFormat,ChangeMobileNumber,isNull,UpdateTokenDevice,ExecuteLogout } from "../../components/common/Common";

//학부모정보변경
const MyInfo = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const mem_idx = Number(localStorage.getItem("mem_idx"));

  const navigate = useNavigate();

  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //회원정보
  const [varMemberInfo,setMemberInfo] = useState({});
  const [varChildrenList,setChildrenList] = useState([]);
  //토큰값
  const [varTokenValue,setTokenValue] = useState(null);

  //회원정보 읽어오기
  const getMyInformation = async () => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_my_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const dataInfo = datas.results;
        setMemberInfo(dataInfo[0]);
        setChildrenList(datas.childrens);
      }
    });
  }

  //FCM TOKEN 메모리에 저장
  const eventFromAndroid = async (e) => {
    localStorage.setItem('fcm_token',e.detail.token);
    setTokenValue(e.detail.token);
    setMemberInfo({...varMemberInfo,mem_device:e.detail.token});
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    //회원정보 저장 객체
    const newMember = {mem_idx:mem_idx,mem_id:"",mem_name:"",old_mobile:"",mem_mobile:"",mem_pwd:"",mem_pwd2:"",mem_device:""};
    setMemberInfo(newMember);

    //네이티브에 기기코드 요청--------------------------------
    const mobileType = navigator.userAgent.toLowerCase();
    //console.log(mobileType);
    window.addEventListener("onFcmInfoSuccess", eventFromAndroid);
    if (mobileType.indexOf('android') > -1) {
      if(window.mamamonte){
        //안드로이드로 보내기
        window.mamamonte.getFcmInfo();
      } 
    } else if (mobileType.indexOf('iphone') > -1 || mobileType.indexOf('ipad') > -1 || mobileType.indexOf('ipod') > -1) {
      if(!isNull(window.webkit) && mobileType.indexOf('mamamonte_ios_app') > -1) {
        window.webkit.messageHandlers.getFcmInfo.postMessage('');
      }
    } 

    getMyInformation();
    return () => {
      if(window.mamamonte){
        window.removeEventListener("onFcmInfoSuccess",eventFromAndroid);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //토큰값 저장
  useEffect(() => {
    if(!isNull(varTokenValue)) {
      UpdateTokenDevice(mem_idx,varTokenValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varTokenValue]); 

  //정보 저장
  const UpdateMemberInformation = async(e) => {
    let pwdString = varMemberInfo.mem_pwd;
    if(!isNull(pwdString)) {
      let pwdString2 = varMemberInfo.mem_pwd2;
      if(pwdString.length < 4 || pwdString.length > 6) {
        alert('비밀번호는 4~6자리가 유효합니다.'); return false;
      } else if(pwdString !== pwdString2) {
        alert('입력하신 2개의 비밀번호가 일치하지 않습니다.'); return false;
      }
    }

    if(!window.confirm('나의 정보를 저장하시겠습니까?')) return false;
    const sendData = {dataInfo:varMemberInfo,childInfo:varChildrenList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_my_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Parents/MyPage');
      } else {
        alert(datas.message);
      }
    });
  }

  //정보변경
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "mem_mobile") {
      setMemberInfo({...varMemberInfo,[name]:ChangeMobileNumber(value)});
    } else {
      setMemberInfo({...varMemberInfo,[name]:value});
    }
  }

  //로그아웃
  const onLogoutHandler = (e) => {
    if(!window.confirm('로그아웃하시겠습니까?')) return false;
    ExecuteLogout();
    navigate('/Parents/Login');
  }

  return(
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'정보수정'} varBackString={'/Parents/MyPage'}/>
      <div className="vh-content-body" style={{marginTop:"40px"}}>
        <div className="mypage-form-wrap">
          <div className="form-group mb15">
            <label className="form-label">학부모명</label>
            <div className="field-group">
              <input type="text" name="mem_name" placeholder="이름을 입력하세요." value={varMemberInfo.mem_name||""} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">자녀명</label>
            <div className="field-group">
              {varChildrenList.map((childs,i)=>(
                <span key={'childs_'+i} className="child-list">{childs.ch_name}</span>
              ))}
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">아이디</label>
            <div className="field-group">
              <input type="text" name="mem_id" value={varMemberInfo.mem_id||""} className="form-control read-only" readOnly/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">연락처 ('-' 제외 숫자만 입력)</label>
            <div className="field-group">
              <input type="text" name="mem_mobile" placeholder="휴재폰번호를 입력하세요." value={ChangeMobileFormat(varMemberInfo.mem_mobile)||""} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">비밀번호 (최대 6자리 입력)</label>
            <div className="field-group">
              <input type="password" name="mem_pwd" placeholder="비밀번호를 입력하세요." value={varMemberInfo.mem_pwd||""} maxLength={6} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">비밀번호 확인</label>
            <div className="field-group">
              <input type="password" name="mem_pwd2" placeholder="확인을 위한 비밀번호를 재입력하세요." value={varMemberInfo.mem_pwd2||""} maxLength={6} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="logout-btn" onClick={e=>onLogoutHandler(e)}>로그아웃</div>
        </div>
        <div className="form-contoller bt-btn">
          <Link to={'/Parents/MyPage'} className="form-contoller-btn btn-no">취소</Link>
					<button className="form-contoller-btn btn-yes" onClick={e=>UpdateMemberInformation(e)}>수정</button>
        </div>
      </div>
    </div>
  );
}
export default MyInfo;